// @flow
//ESHOP: Produktova fotogalerie
import EshopPhotogallery from 'fg-frontend/components/EshopPhotogallery';
//ESHOP: 3D model v ramci produktove fotogalerie (odeberte, pokud neni pozadovana funkcionalita 3D modelu (nastavitelne na fotogalerii))
import EshopModel3D      from 'fg-frontend/components/EshopModel3D';
//ESHOP: Lupa v ramci produktove fotogalerie (odeberte, pokud neni pozadovana funkcionalita lupy (nastavitelne na fotogalerii))
import EshopImageMagnify from 'fg-frontend/components/EshopImageMagnify';
//ESHOP: Podpora galerie v popupu (odeberte, pokud neni pozadovano chovani galerie v popupu)
import EshopGalleryPopup from 'fg-frontend/components/EshopGalleryPopup';
//ESHOP: Podpurna komponenta pro vlozeni zbozi do kosiku (odeberte, pokud nemate v projektu nakupni proces)
import EshopOrderForm    from 'fg-frontend/components/EshopOrderForm';

import ProductListSlider from './components/ProductListSlider';

//ESHOP: fulltextovy naseptavac, povolte, pokud je aktivni fulltext feature
import EshopFulltextAutocomplete from 'fg-frontend/src/components/EshopFulltextAutocomplete';

//ESHOP: fulltextovy naseptavac, povolte, pokud je aktivni fulltext feature
import RwdFilterFormToggle from './components/RwdFilterFormToggle';

// ESHOP: Handler komponenta pro pridani/odebrani produktu z oblibenych/porovnavani (odeberte, pokud na projektu nepouzivate ani oblibene ani porovnavani)
import EshopUserToolsHandler from './components/EshopUserToolsHandler';

export default (props) => {
  switch ( props.decorator || props.is ) {
    case 'EshopPhotogallery':
      return EshopPhotogallery;
    case 'EshopModel3D':
      return EshopModel3D;
    case 'EshopImageMagnify':
      return EshopImageMagnify;
    case 'EshopGalleryPopup':
      return EshopGalleryPopup;
    case 'EshopOrderForm':
      return EshopOrderForm;
    case 'ProductListSlider':
      return ProductListSlider;
    case 'EshopFulltextAutocomplete':
      return EshopFulltextAutocomplete;
    case 'RwdFilterFormToggle':
      return RwdFilterFormToggle;
    case 'EshopUserToolsHandler':
      return EshopUserToolsHandler;
  }
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureEshopComponents.js